import { useState } from 'react'
import { useNavigate, Navigate } from 'react-router-dom'
import { useAuth } from '../store/authStore.js'
import { LogIn, AlertCircle } from 'lucide-react'
import opLogo from '../assets/op.png'
import Footer from '../components/layout/Footer.jsx'

export default function Login() {
  const { user, login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const nav = useNavigate()

  if (user) return <Navigate to="/" replace />

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null); setLoading(true)
    try {
      await login(email, password)
      nav('/')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-teal-50 via-white to-teal-100/50">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={opLogo} alt="O+P Consult" className="h-14 w-auto mx-auto" />
          <p className="font-serif text-[18px] font-medium tracking-[-0.015em] text-ink-soft mt-3">mindnet&thinsp;·&thinsp;academy</p>
        </div>

        <div className="card p-8">
          <h1 className="text-2xl font-bold mb-1">Anmelden</h1>
          <p className="text-ink-soft text-sm mb-6">Bitte melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">E-Mail-Adresse</label>
              <input
                type="email" autoFocus required autoComplete="email"
                className={`input ${error ? 'input-error' : ''}`}
                value={email} onChange={e => setEmail(e.target.value)}
                placeholder="vorname.nachname@unternehmen.de"
              />
            </div>
            <div>
              <label className="label">Passwort</label>
              <input
                type="password" required autoComplete="current-password"
                className={`input ${error ? 'input-error' : ''}`}
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div className="flex items-start gap-2 text-rose-600 text-sm">
                <AlertCircle size={16} className="mt-0.5" />
                <span>{error}</span>
              </div>
            )}
            <button type="submit" disabled={loading} className="btn-primary w-full">
              <LogIn size={18} /> {loading ? 'Anmeldung läuft…' : 'Einloggen'}
            </button>
          </form>

        </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
